export default "__VITE_ASSET__aD0tqlDu__"